import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../../globals';
import { Configuration } from '../../app.configuration';

@Injectable()
export class AccountService {
  private _updateprofile = myGlobals.apiurl + 'profile/me';
  private _checkprofile = myGlobals.apiurl + 'profile/me';
  private _checkpassword = myGlobals.apiurl + 'checkpassword';

  // START OF UBER FOR ALL API CALLS

  private _changeEmail = myGlobals.apiurl + 'customer/email';
  private _changePassword = myGlobals.apiurl + 'customer/password/me';
  private _changePhonenum = myGlobals.apiurl + 'customer/phoneNumber';
  private _changeFirstName = myGlobals.apiurl + 'customer/profile';
  private _checkPhone = myGlobals.apiurl + 'customer/phoneValidation';
  private _otpresend = myGlobals.apiurl + 'customer/resendOtp';
  private _profile = myGlobals.apiurl + 'customer/profile';
  private _signotp = myGlobals.apiurl + 'customer/verifyVerificationCode';
  private _uploadImage = myGlobals.apiurl + 'utility/uploadImage';
  // END OF UBER FOR ALL API CALLS

  constructor(private _http: HttpClient, private _cookie: Configuration) {}

  // START OF UBER FOR ALL FUNCTIONS

  // change email
  changeEmail(user: any) {
    return this._http.patch(this._changeEmail, user, {
      headers: this._cookie.header
    });
  }

  // change email
  getProfile(user: any) {
    return this._http.get(this._profile, { headers: this._cookie.header });
  }

  // change password
  changePassword(user: any) {
    console.log(user);

    return this._http.patch(this._changePassword, user, {
      headers: this._cookie.header
    });
  }

  // change password
  changePhoneNum(user: any) {
    return this._http.patch(this._changePhonenum, user, {
      headers: this._cookie.header
    });
  }

  // change first name
  changeFirstName(user: any) {
    return this._http.patch(this._changeFirstName, user, {
      headers: this._cookie.header
    });
  }

  // Change Profile photo
  updateProfileImage(imageUrl) {
    return this._http.patch(this._profile, imageUrl, {
      headers: this._cookie.header
    });
  }
  uploadImage(image) {
    const formData = new FormData();
    formData.append('image', image);
    return this._http.post(this._uploadImage, formData);
  }
  // END OF UBER FOR ALL FUNCTIONS

  // PROFILE CHANGING CALL
  updateprofile(user: any) {
    return this._http.put(this._updateprofile, user, {
      headers: this._cookie.header
    });
  }

  // CHECK PASSWORD CALL
  checkpassword(user: any) {
    return this._http.post(this._checkpassword, user, {
      headers: this._cookie.header
    });
  }

  //resend otp
  signupotpresend(user: any) {
    return this._http.post(this._otpresend, user, {
      headers: this._cookie.header
    });
  }

  // CHECK PHONENUMBER CALL
  checkPhone(user: any) {
    return this._http.post(this._checkPhone, user, {
      headers: this._cookie.header
    });
  }

  // SIGNUP OTP

  signupotp(user: any) {
    return this._http.post(this._signotp, user, {
      headers: this._cookie.header
    });
  }
}
